/* eslint-disable import/prefer-default-export, no-underscore-dangle */
export const insertCss = (...styles) => {
  const removeCss = styles.map((style) => (style && style._insertCss ?
    style._insertCss() : false));
  return () => removeCss.forEach((dispose) => dispose());
};
